import { render, staticRenderFns } from "./online-pk-statistics.vue?vue&type=template&id=c045ff0e&scoped=true&"
import script from "./online-pk-statistics.vue?vue&type=script&lang=js&"
export * from "./online-pk-statistics.vue?vue&type=script&lang=js&"
import style0 from "./online-pk-statistics.vue?vue&type=style&index=0&id=c045ff0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c045ff0e",
  null
  
)

export default component.exports